window.__recentConsoleLogs = [];
const MAX_LOGS = 100;

["log", "warn", "error", "info"].forEach((level) => {
    const original = console[level];
    console[level] = function (...args) {
        try {
            window.__recentConsoleLogs.push({
                level,
                args,
                ts: new Date().toISOString(),
            });
            if (window.__recentConsoleLogs.length > MAX_LOGS) {
                window.__recentConsoleLogs.shift();
            }
        } catch (err) {
            
        }
        original.apply(console, args);
    };
});